import { m } from '@pacevault/i18n/messages.js';
import type { ZoneBand } from '@/lib/colors/zoneColors.ts';

const ZONE_NAME_LABELS: Record<string, () => string> = {
  recovery: m.ui_zone_recovery,
  easy: m.ui_zone_easy,
  tempo: m.ui_zone_tempo,
  threshold: m.ui_zone_threshold,
  vo2max: m.ui_zone_vo2max,
  aerobic: m.ui_zone_aerobic,
  active_recovery: m.ui_zone_active_recovery,
  endurance: m.ui_zone_endurance,
  anaerobic: m.ui_zone_anaerobic,
  neuromuscular: m.ui_zone_neuromuscular,
};

export const zoneName = (band: Pick<ZoneBand, 'name'>): string | undefined =>
  ZONE_NAME_LABELS[band.name]?.();

export const zoneLabel = (band: Pick<ZoneBand, 'zone' | 'name'>): string => {
  const name = zoneName(band);
  if (name === undefined) return band.zone;
  return `${band.zone} ${name}`;
};
